/* sticky Bar */
function stickyHeight(){
  $(".product_variant_grouping_new").css("min-height","");
  var product_variant_grouping_new = $(".product_variant_grouping_new").outerHeight(true);
  $(".product_variant_grouping_new").css("min-height",product_variant_grouping_new+"px");
}
stickyHeight();
$(window).resize(function(){
  stickyHeight();
});

function productPageScript(){
  if($(".Product_template_main_new").length > 0)
  {
    var stickyHeaderTopSticky = $(".Product_template_main_new").offset().top +  $(".Product_template_main_new").outerHeight(true) - $(".header").outerHeight(true);
    console.log(stickyHeaderTopSticky);
    $(window).scroll(function(){
    
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("sticky_header_new") == false)
          {
              $('body').addClass("hide_atc_button_new");
              setTimeout(function(){
                $('body').addClass("delay_sticky_header_new");
              }, 100);
              setTimeout(function(){
                $('body').addClass('sticky_header_new');
              }, 400);
          }
      } else {
          if ($('body').hasClass("sticky_header_new")) {
            $('body').removeClass("sticky_header_new");
            setTimeout(function(){
              $('body').removeClass("hide_atc_button_new");
              $("body").removeClass("delay_sticky_header_new");  
            }, 400);
          }
      }
    });
  }

  $(".read_more_open").click(function name() {
    $(this).parents(".nss_short_description_inner_new").addClass("active");
  })
  $(".read_more_close").click(function name() {
    $(this).parents(".nss_short_description_inner_new").removeClass("active");
  })

  /* Sticky Variant */
  $(".product_grouping_list_title_new").click(function() {
    if($(this).parents(".product_grouping_list_inner_new").find(".product_grouping_list_mainloops_new").hasClass("active") == false){
      $(".variant_box_new .variant-picker__option-values").removeClass("active");
      $(".product_grouping_list_mainloops_new").removeClass("active");
      $(this).parents(".product_grouping_list_inner_new").find(".product_grouping_list_mainloops_new").addClass("active");
    }
    else{
      $(".product_grouping_list_mainloops_new").removeClass("active");
    }
  })

  $(".product_grouping_list_innerloops_mainboxs_new").click(function() {
    $(".product_grouping_list_mainloops_new").removeClass("active");
  })
  
  $(".variant-picker__field .form__label").click(function() {
    if($(this).parents(".variant_box_new").find(".variant-picker__option-values").hasClass("active") == false){
      $(".variant_box_new .variant-picker__option-values").removeClass("active");
      $(".product_grouping_list_mainloops_new").removeClass("active");
      $(this).parents(".variant_box_new").find(".variant-picker__option-values").addClass("active");
    }
    else{
      $(".variant_box_new .variant-picker__option-values").removeClass("active");
    }
  })

  $(".variant_label_new").click(function() {
    $(".variant_box_new .variant-picker__option-values").removeClass("active");
  })

  $(document).mouseup(function(e) 
  {
      var container = $(".product_grouping_list_main_new, .variant_box_new");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $(".product_grouping_list_mainloops_new").removeClass("active");
          $(".variant_box_new .variant-picker__option-values").removeClass("active");
      }
  });

}
productPageScript()

function initComplementarySlider() {
  const sliderEl = document.querySelector('.nss_product_complementary_slider');

  // Check if slider exists and isn't initialized yet
  if (sliderEl && !sliderEl.classList.contains('swiper-initialized')) {
    new Swiper(sliderEl, {
      loop: true,
      grabCursor: false,
      spaceBetween: 40,
      slidesPerGroup: 1,
      slidesPerView: 1,
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });

    console.log('Swiper initialized');
  }
}

initComplementarySlider()
document.addEventListener('complementarySlider:init', initComplementarySlider)
document.addEventListener('productPageScript:init', productPageScript)

/* nss_product_meta_gallery_slider */
function imageGallerySlider(){
  new Swiper('.nss_product_meta_gallery_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 20,
    slidesPerGroup: 1,
    slidesPerView: 3,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        slidesPerView: "auto",
        spaceBetween: 18
      },
      750: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      990: {
      },
      1440: {
      }
    }
  })
}
imageGallerySlider()
document.addEventListener('imageGallerySlider:init', imageGallerySlider)
/* nss_product_object_review_slider */
new Swiper('.nss_product_object_review_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 60,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  observer: true,
  observeParents: true,
  centeredSlides: true,
  breakpoints: {
    0: {
      freeMode: !1,
      spaceBetween: 37
    },
    750: {
      spaceBetween: 40
    },
    990: {
      spaceBetween: 60
    },
    1440: {
    }
  }
})

